import React from "react";

const Parallax = () => {
  return (
    <div className="text-center" id="text-para">
      <h1>
        Step into our virtual halls and discover a vast collection of pins
        created by a community of passionate and talented artists. From
        intricate designs to bold statements, our pins showcase a diverse range
        of styles and techniques that will captivate you.
      </h1>
    </div>
  );
};

export default Parallax;
